export const SENTRY_URL =
  'https://4c021a2850f94564a4f606c5f5c791bf@o4505247884640256.ingest.sentry.io/4505247886540800';
